import { Provider } from "@angular/core";

export class WindowRef {
    getNativeWindow (): any {
        return window;
    }
}

export class DocumentRef {
    getNativeDocument (): any {
        return document;
    }
}

declare function unescape (s: string): string;

declare function escape (s: string): string;

export const dataEncode = (stringData) => btoa(unescape(encodeURIComponent(stringData)));
export const dataDecode = (encodedData) => decodeURIComponent(escape(atob(encodedData)));

export const BROWSER_GLOBALS_PROVIDERS: Provider[] = [WindowRef, DocumentRef];